import {bootstrapModal} from "../../lib/bootstrapModal";
import {escapeHTML} from "../../lib/escapeHTML";
import {Messages} from "../../messages/Messages";
import {WidgetHost} from "./WidgetHost";

const messages = new Messages();

export class WidgetsSettingsModal {
	static show(host: WidgetHost) {
		const config = host.layoutConfig
		const rows = host.availableDescriptors
			.map(d => {
				const entry = config.find(c => c.id == d.id)
				const checked = entry && entry.visible ? 'checked' : ''
				return `
<div class="form-check form-switch">
	<input class="form-check-input" type="checkbox" role="switch" id="dashboard-widget-${d.id}" data-widget-id="${d.id}" ${checked}>
	<label class="form-check-label" for="dashboard-widget-${d.id}">${escapeHTML(messages.get(d.titleCode))}</label>
</div>`
			})
			.join('')

		const {content, modal, buttonOk} = bootstrapModal({
			title: messages.get('dashboard.widgets.settings.title'),
			body: rows,
			footer: `
<button type="button" class="btn btn-danger me-auto" data-handler="reset">${escapeHTML(messages.get('dashboard.widgets.settings.reset'))}</button>
<button type="button" class="btn btn-secondary text-capitalize" data-bs-dismiss="modal">${escapeHTML(messages.get('button.cancel'))}</button>
<button type="button" class="btn btn-primary text-capitalize" data-handler="submit">${escapeHTML(messages.get('button.apply'))}</button>`
		})

		content.querySelector<HTMLElement>('[data-handler="reset"]')!
			.addEventListener('click', () => {
				host.resetLayout()
				modal.hide()
			})

		buttonOk?.addEventListener('click', () => {
			const visibleById = new Map<string, boolean>()
			content.querySelectorAll<HTMLInputElement>('input[data-widget-id]')
				.forEach(input => visibleById.set(input.getAttribute('data-widget-id')!, input.checked))
			host.applyConfig(visibleById)
			modal.hide()
		})

		modal.show()
	}
}
